import { api } from "@/builders/axios";
import { FilterParams } from "@/builders/types/filter-params";
import { CreateQAReplies, QAReplies, QARepliesData } from "@/builders/types/qa";

const post = function (data: CreateQAReplies) {
  return api.post("qa/replies", data);
};
const get = function (id: number) {
  return api
    .get<{ data: QARepliesData }>(`qa/replies/${id}`)
    .then(({ data }) => data);
};

const list = function (
  params?: FilterParams<{
    question: number | undefined;
  }>
) {
  return api.get<QAReplies>("qa/replies", { params }).then(({ data }) => data);
};

const del = function (id: number) {
  return api.delete(`qa/${id}`).then(({ data }) => data);
};

const put = function attempt(variables: {
  id: number;
  data: {
    answer: string;
  };
}) {
  const { id, data } = variables;
  return api.put(`qa/${id}`, data).then(({ data }) => data);
};
export const qa_answers = {
  post,
  get,
  list,
  del,
  put,
};

